import type { HomeStrings } from "../../types";

export const home: HomeStrings = {
  hero: {
    title: "一块无限画布，治好终端过载。",
    subtitle: "终端、编辑器、浏览器，自由漂浮在一块可任意缩放的画面上。",
    platforms: "macOS、Windows 和 Linux",
  },
  download: {
    mac: "下载 macOS 版",
    windows: "下载 Windows 版",
    linux: "下载 Linux 版",
    latest: "下载最新版本",
  },
  heroNewsletter: {
    placeholder: "订阅资讯",
    subscribe: "订阅",
    done: "订阅成功，记得查收邮件。",
  },
  manifesto: {
    title: "它不是又一个窗口管理器。",
    body: "平铺布局只是把你已有的窗口重新摆一摆。Cate 想做的是另一件事：当 AI Agent 进入开发循环之后，重新思考我们该怎么工作、怎么写代码。每个项目对应一个独立的空间化工作区，你的工具和你的 Agent 共处同一块画面，各自守着自己的上下文。",
  },
  testimonials: {
    title: "开发者都在看",
    subtitle: "来自 Hacker News 发布帖的真实反响。",
  },
  downloadCta: {
    titleLines: ["为 Agent 时代", "重新定义工作区。"],
  },
  newsletter: {
    title: "保持关注",
    body: "第一时间获取新功能、版本发布和实用技巧。不发垃圾邮件，随时可退订。",
    placeholder: "you@example.com",
    subscribe: "订阅",
    success: "订阅成功！欢迎邮件已经发到你的收件箱，请查收。",
    errorGeneric: "出了点问题",
    errorNetwork: "网络出错了，请重试",
  },
  unsubscribe: {
    noEmail: "没有提供邮箱地址。",
    loading: "正在退订……",
    doneTitle: "已为你退订",
    doneBody: "{email} 已从 CATE 资讯列表中移除，今后不会再收到我们的邮件。",
    back: "返回 CATE",
    error: "出了点问题，请重试。",
  },
};
